import { Common, color } from '@stockbit/ui';

import AuthCardLayout from 'global/AuthCardLayout';
import Image from 'global/Image';

import { ImageWrapper, TextWrapper, Title, Description } from './styled';

const { Button, Text } = Common;

interface PhoneErrorProps {
  onBackLogin: () => void;
  onBackChangePhone: () => void;
}

export default function PhoneError({
  onBackLogin,
  onBackChangePhone,
}: PhoneErrorProps): JSX.Element {
  return (
    <AuthCardLayout withLogo={false} wrapperClassName="register">
      <ImageWrapper>
        <Image src="/illustration/phone-registered.svg" alt="Phone Error" />
      </ImageWrapper>

      <TextWrapper>
        <Title>Nomor HP Sudah Terdaftar di Stockbit</Title>

        <Description>
          Silahkan login atau gunakan nomor lain untuk pendaftaran baru.
        </Description>
      </TextWrapper>

      <Button
        id="back-login-button"
        type="primary"
        height="44px"
        block
        onClick={onBackLogin}
      >
        <Text family="bold" color={color.light}>
          Login
        </Text>
      </Button>

      <Button
        id="back-change-phone"
        type="default"
        height="44px"
        block
        onClick={onBackChangePhone}
      >
        <Text family="bold" color={color.primary}>
          Gunakan Nomor HP Lain
        </Text>
      </Button>
    </AuthCardLayout>
  );
}
